<template>
    <form class="column is-8 newsletter-form">
        <template v-if="! loading && ! subscribed">
            <input type="hidden" name="format" value="h" />
            <div class="columns">
                <div class="column is-6">
                    <input-field :label="lang('Nome')+' *'" name="firstname"
                                 v-model="input.firstname"
                                 :errors="errors"></input-field>
                </div>
                <div class="column is-6">
                    <input-field :label="lang('Cognome')+' *'" name="lastname"
                                 v-model="input.lastname"
                                 :errors="errors"></input-field>
                </div>
            </div>
            <input-field :label="lang('Indirizzo Email')+' *'"
                         type="email" name="email"
                         v-model="input.email"
                         :errors="errors"></input-field>
            <checkbox name="privacy" v-model="input.privacy"
                      :errors="errors"> <span v-text="lang( 'Accetto' )"></span> <a target="_blank" href="/policies/privacy" v-text="lang('l\'informativa della privacy')"></a></checkbox>

            <div class="button-container has-text-centered">
                <button @click.prevent="send"
                        class="button is-primary" v-text="lang('Iscriviti')"></button>
            </div>
        </template>
        <div v-if="loading" class="loading">
            <div class="has-text-centered">
                <div class="icon"><i class="fas fa-5x fa-spin fa-circle-notch"></i></div>
            </div>
        </div>
        <div v-if="! loading && subscribed" class="contact-thx has-text-centered">
            <p v-text="lang(response)"></p>
        </div>
    </form>
</template>
<script>
    import axios from 'axios';
    import FormErrors from './../Classes/FormErrors'

    export default {
        data() {
            return {
                loading: false,
                subscribed: false,
                response: 'Iscritto',
                input: {
                    firstname: '',
                    lastname: '',
                    email: '',
                    privacy: false
                },
                errors: new FormErrors()
            }
        },
        methods: {
            send() {
                this.loading = true
                axios.post('/dem/subscribe', this.input)
                    .then( response => {
                        this.response = response.data;
                        this.loading = false;
                        this.subscribed = true;
                    } )
                    .catch( error => {
                        if( error.response.status === 422 ) {
                            this.errors.record( error.response.data.errors )
                            this.loading = false;
                            return
                        }
                        this.response = error.response.data;
                        this.loading = false;
                        this.subscribed = true;
                    } )
            }
        }
    }
</script>